import { useMemo } from 'react';
import { Box, ProgressBar as MuiProgressBar, styled, useResolution } from '@lingoda/ui';

const MAX_STEP_TO_SHOW_ROUNDED_PROGRESS = 2;

interface ProgressBarProps {
    activeStep: number;
    totalSteps: number;
}

export const ProgressBar = (props: ProgressBarProps) => {
    const isPhone = useResolution('phone');
    const progressValue = (props.activeStep / props.totalSteps) * 100;

    const progressRoundedValue = useMemo(() => {
        if (!isPhone) {
            return true;
        }
        if (props.activeStep <= MAX_STEP_TO_SHOW_ROUNDED_PROGRESS) {
            return 'right';
        }

        return false;
    }, [isPhone, props.activeStep]);

    return (
        <StyledProgressBarWrapper>
            <MuiProgressBar
                size="large"
                value={progressValue}
                fullWidth
                rounded={progressRoundedValue}
            />
        </StyledProgressBarWrapper>
    );
};

const StyledProgressBarWrapper = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    maxWidth: theme.spacing(54),
    [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
    },
}));
